import { CService } from "./class.base.service";

class ActionSubCategoryService extends CService {}

const actionSubCategoryService = new ActionSubCategoryService("action-subcategories");
export default actionSubCategoryService